import { axiosInstance } from '../utils/axios';

import { isEmail } from '../utils/isEmail';

export const postRegister = ({ email, id, name }, extraData) =>
  axiosInstance.post(
    '',
    {
      email,
      id,
      name,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.create',
      },
    },
  );

export const postActivateAccount = ({ id, nonce }, extraData) =>
  axiosInstance.post(
    '',
    {
      id,
      nonce,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.activate',
      },
    },
  );

export const postReactivateAccount = ({ id }, extraData) =>
  axiosInstance.post(
    '',
    {
      id,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.reactivate',
      },
    },
  );

export const postSetPassword = ({ id, password }, extraData) =>
  axiosInstance.post(
    '',
    {
      id,
      password,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.setPassword',
      },
    },
  );

export const postRequestReset = ({ data }, extraData) => {
  const isEmailData = isEmail(data);

  return axiosInstance.post(
    '',
    isEmailData ? { email: isEmailData } : { id: data },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: isEmailData
          ? 'account.requestResetViaEmail'
          : 'account.requestReset',
      },
    },
  );
};

export const postLogin = ({ id, password }, extraData) => {
  if (id.includes('@')) {
    return axiosInstance.post(
      '',
      {
        email: id,
        password,
      },
      {
        ...extraData,
        params: {
          ...extraData?.params,
          method: 'account.login.email',
        },
      },
    );
  }

  return axiosInstance.post(
    '',
    {
      id,
      password,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.login',
      },
    },
  );
};

export const postLogout = () =>
  axiosInstance.post('', null, {
    params: {
      method: 'account.logout',
    },
  });
